"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import _ from "underscore";
import { autolink } from "../autolink";
import DOMPurify from "dompurify";
function lines(text) {
  return text.split("\n");
}
function line(text, idx) {
  var br = /* @__PURE__ */ jsx("br", {});
  const textWithFixedAngleBrackets = text.replace(
    /<([^<> ]*[.:][^<> ]*)>/g,
    (match, betweenAngleBrackets) => `&lt;${betweenAngleBrackets}&gt;`
  );
  const sanitizedText = DOMPurify.sanitize(textWithFixedAngleBrackets, {
    USE_PROFILES: { html: true }
  });
  const linkedText = autolink(sanitizedText);
  const sanitizedLinkedText = DOMPurify.sanitize(linkedText, {
    USE_PROFILES: { html: true }
  });
  return /* @__PURE__ */ jsxs("span", { children: [
    /* @__PURE__ */ jsx("span", { dangerouslySetInnerHTML: { __html: sanitizedLinkedText } }),
    " ",
    idx === 0 ? "" : br
  ] }, "line_" + idx);
}
function paragraph(para, index) {
  return /* @__PURE__ */ jsx("p", { children: _.map(lines(para), line) }, "paragraph_" + index);
}
function paragraphs(props) {
  var withoutCRs = (props.text || "").replace(/\r\n|\r/g, "\n");
  return withoutCRs.split("\n\n");
}
function SimpleHtmlFormat(props) {
  return /* @__PURE__ */ jsx("div", { "data-component": "SimpleHtmlFormat", children: _.map(paragraphs(props), paragraph) });
}
export default SimpleHtmlFormat;
